<template>
  <!-- Impossible de passer le context vuetify au toaster obliger de passer par les balises font-awesome -->
  <FaIcon class="text-warningPrimary" :icon="['fas', 'circle-exclamation']" />
</template>
